module.exports = __webpack_public_path__ + "static/img/bg-overview@t.fffd337.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem-life-science/bg-overview@t.jpg
// module id = rMYl
// module chunks = 0